import { StyleSheet, Text, View, Pressable } from "react-native";
import React from "react";

const ComfirmLayout = ({ objectName, onPress }) => {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [
        {
          backgroundColor: pressed ? "rgb(210, 230, 255)" : "white",
        },
        styles.container,
      ]}
    >
      <Text style={styles.text}>您抽到的是：</Text>
      <Text style={styles.reasultText}>{objectName}</Text>
      <Text style={styles.text}>湊滿「尊師慶典」四字</Text>
      <Text style={styles.text}>就可換一份神秘小禮物喔！</Text>
      <Text style={styles.buttonText}>請點擊我確認</Text>
    </Pressable>
  );
};

export default ComfirmLayout;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F9DDCE",
    padding: 20,
    borderRadius: 20,
    borderColor: "#CDC4B2",
    borderWidth: 5,
  },
  text: {
    fontSize: 18,
  },
  reasultText: {
    fontSize: 80,
    fontWeight: "bold",
    color: "red",
  },
  buttonText: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#F76205",
  },
});
